import { CONTACT, phoneDisplay, phoneHref, waLink } from "@/data/products";
import Reveal from "@/components/site/Reveal";

const ROWS = [
  ["FIRM", <>AHUJA BROTHERS<sup>®</sup></>, null],
  ["ESTD.", "1967", null],
  ["PROP.", CONTACT.owner, null],
  ["YARD", CONTACT.address, null],
  ["MOB", phoneDisplay(), phoneHref()],
  ["MAIL", CONTACT.email.toUpperCase(), `mailto:${CONTACT.email}`],
];

export default function Contact() {
  return (
    <section className="section-paper contact-section" data-testid="contact-section">
      <Reveal>
        <div className="section-head">
          <h2 className="section-title">ASK FOR TODAY&apos;S RATE</h2>
        </div>
      </Reveal>

      <div className="contact-grid">
        <Reveal delay={0.05}>
          <div className="deal-direct" data-testid="deal-direct">
            <span className="why-num mono-tag">04</span>
            <h3 className="why-title">DEAL DIRECT</h3>
            <p className="why-body">
              You speak with Rinku Ahuja himself. No call centre, no runaround.
            </p>
            <figure className="owner-figure" data-testid="owner-figure">
              <img
                src="/owner.jpg"
                alt="Rinku Ahuja, proprietor of Ahuja Brothers"
                className="owner-img"
                loading="lazy"
                data-testid="owner-photo"
              />
              <figcaption className="mono-tag owner-caption">
                RINKU AHUJA — PROP., AHUJA BROTHERS<sup>®</sup>
              </figcaption>
            </figure>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div>
            <div className="title-block">
              {ROWS.map(([k, v, href]) => (
                <div className="tb-row" key={k} data-testid={`contact-row-${k.toLowerCase()}`}>
                  <span className="tb-key mono-tag">{k}</span>
                  {href ? (
                    <a
                      className="tb-val tb-link"
                      href={href}
                      data-testid={k === "MOB" ? "contact-phone-link" : "contact-email-link"}
                    >
                      {v}
                    </a>
                  ) : (
                    <span className="tb-val">{v}</span>
                  )}
                </div>
              ))}
            </div>

            <div className="contact-cta">
              <a
                className="btn-furnace"
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-button"
              >
                WHATSAPP FOR RATE
              </a>
              <a className="btn-furnace" href={phoneHref()} data-testid="contact-call-button">
                CALL NOW
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
